<template>
  <div>
    <div class="title-coin">
      <p class="ta-c">
        {{ coinName }}
        <span
          v-if="chainName && chainName.length > 0"
          class="chain-name pr6 pl6"
        >
          {{ chainName }}
        </span>
      </p>
    </div>
    <div class="menu-list" flex>
      <router-link :to="`/balances/deposit/${coinName}`" class="w4 menu">{{
        $t("main.market.deposit")
      }}</router-link>
      <router-link :to="`/balances/withdraw/${coinName}`" class="w4 menu">{{
        $t("main.market.withdrawal")
      }}</router-link>
      <router-link :to="`/balances/log/${coinName}`" class="w4 menu">{{
        $t("main.market.history")
      }}</router-link>
    </div>
  </div>
</template>

<script>
import Api from "@/common/Api";

export default {
  data() {
    return {
      coinName: "",
      coinsArray: "", // coins api의 coins Array
      chainName: "", //
    };
  },
  computed: {},
  async created() {
    this.coinName = this.$route.params.coin || "KRW";
    try {
      const res = await Api.Setting.getCoinInfo();
      this.getCoinsArray = res.data.result;

      const getCoinObject = _.find(
        this.getCoinsArray,
        (ele) => ele.code === this.coinName
      );

      this.chainName = getCoinObject.chainName;

      return this.chainName;
    } catch (error) {
      return;
    }
  },
};
</script>

<style scoped lang="scss">
@import "/src/styles/import.scss";

div {
  box-sizing: border-box;
}
p {
  margin-bottom: 0;
}
.title-coin {
  padding: 10px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
  .chain-name {
    font-size: 14px;
    color: #00b473;
    border-radius: 16px;
    border: solid 1px #00b473;
    background: rgba(0, 180, 115, 0.05);
  }
}
.menu-list {
  position: relative;
  border-top: 1px solid $white-color;
  border-bottom: 1px solid $white-color;
  padding: 0px 12px;
  .menu {
    color: #b4b4b4;
    position: relative;
    bottom: -1px;
    font-size: 15px;
    padding: 9px;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    // color: $main-color;
    &.router-link-exact-active {
      color: $main-color;
      border-bottom: 2px solid $main-color;
    }
  }
}
</style>
